<template>
    <div class="indexContent">
        <div class="indexBanner">
            <transition-group name="fadeIn">
                <div class="slide" v-for="(item,index) in indexData.banner" v-if="index === curpage" :key="index">
                    <a :href="item.url" target="_blank">
                        <img :src="item.img" alt="" class="banner">
                    </a>
                </div>
            </transition-group>
            <div class="indicateBox center">
                <div :class="['indicate',index === curpage ? 'indicateOn' : '']" v-for="(item,index) in indexData.banner" :key="index" @click="indicateTap(index)"></div>
            </div>
        </div>
        <!-- 爆品推荐&新品上线 -->
        <div class="productContent spb">
            <div class="productBox">
                <img src="../assets/icon/productTitle01.png" class="productTitle">
                <div class="productList spb">
                    <div class="product column" v-for="(item,index) in indexData.baokuan" :key="index" @click="categoryTap(item.url)">
                        <el-image :src="item.img" fit="cover" class="productImg"></el-image>
                        <div class="productName">{{ item.name }}</div>
                        <div class="productTipsList flex">
                            <div class="productTips" v-for="(el,ii) in item.biaoqian" :key="ii">{{ el }}</div>
                        </div>
                        <div class="price"><span class="priceIcon">￥</span>{{ item.price }}</div>
                    </div>
                </div>
            </div>
            <div class="productBox">
                <img src="../assets/icon/productTitle02.png" class="productTitle">
                <div class="productList spb">
                    <div class="product column" v-for="(item,index) in indexData.xinpin" :key="index" @click="categoryTap(item.url)">
                        <el-image :src="item.img" fit="cover" class="productImg"></el-image>
                        <div class="productName">{{ item.name }}</div>
                        <div class="productTipsList flex">
                            <div class="productTips" v-for="(el,ii) in item.biaoqian" :key="ii">{{ el }}</div>
                        </div>
                        <div class="price"><span class="priceIcon">￥</span>{{ item.price }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 开发 -->
        <div class="indexModule">
            <div class="moduleTitle">开发</div>
            <div class="developList flex">
                <div class="developBox flex" v-for="(item,index) in indexData.kaifa" :key="index" @click="categoryTap(item.url)">
                    <el-image :src="item.img" fit="cover" class="developImg"></el-image>
                    <div class="develop">
                        <div class="title">{{ item.name }}</div>
                        <div class="tipsList flex">
                            <div class="tips" v-for="(el,ii) in item.biaoqian" :key="ii">{{ el }}</div>
                        </div>
                        <div class="price"><span class="priceIcon">￥</span>{{ item.price }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 服务 -->
        <div class="indexModule">
            <div class="moduleTitle">服务</div>
            <div class="developList flex">
                <div class="serviceBox flex" v-for="(item,index) in indexData.fuwu" :key="index" @click="categoryTap(item.url)">
                    <el-image :src="item.img" fit="cover" class="serviceImg"></el-image>
                    <div class="service">
                        <div class="title">{{ item.name }}</div>
                        <div class="text"></div>
                        <div class="price"><span class="priceIcon">￥</span>{{ item.price }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 右侧悬浮 -->
        <div class="contactList">
            <div class="contactpos">
                <el-image :src="require('@/assets/icon/contact01.png')" fit="cover" class="contactIcon"></el-image>
                <div class="contactName">联系客服</div>
                <div class="contactContent contactShow">
                    <div class="contactHi">Hi,联系专属客服</div>
                    <div class="contactTitle">为您寻找最适合的产品解决方案</div>
                    <div class="contactBox column">
                        <el-image :src="indexData.kefu" class="contactImg"></el-image>
                        <div class="contactTips">扫码添加客服微信</div>
                    </div>
                </div>
            </div>
            <div class="contactpos">
                <el-image :src="require('@/assets/icon/contact02.png')" fit="cover" class="contactIcon"></el-image>
                <div class="contactName">电话咨询</div>
                <div class="telBox contactShow">
                    <div style="display: flex;">
                        <el-image :src="require('@/assets/icon/contact03.png')" fit="cover" class="telIcon"></el-image>
                        <div>
                            <div class="telNum">{{ indexData.tel }}</div>
                            <div class="flex">
                                <div class="telName">{{ indexData.lianxiren }}</div>
                                <div class="workTime">（{{ indexData.gongzuotime }}）</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                userDetail: 0,
                loginShow: false,
                indexData: {},
                curpage: 0
            }
        },
        mounted(){
            this.userDetail = JSON.parse(localStorage.getItem("userInfo")) || 0
            this.getIndexData()
        },
        methods: {
            // banner动画
            setTimer(){
                this.timer=setInterval(()=>{
                    this.curpage++;
                    if(this.curpage==this.indexData.banner.length){
                        this.curpage=0
                    }
                },5000)
            },
            // banner切换点
            indicateTap(e){
                this.curpage = e
            },
            // 获取首页数据
            getIndexData(){
                this.request.get("index/index/center",{
                    params:{
                       
                    }
                })
                .then(res=>{
                    this.indexData = res.data
                    document.title = res.data.title
                    this.setTimer();
                })
            },
            // 跳转登录
            getLogin(){
                this.$router.push({ path:'/login/login' })
            },
            // 自定义跳转
            categoryTap(e){
                this.$router.push({ path:e })
            },
            // 入驻服务商跳转
            settleBtnTap(){
                window.location.href = this.categoryData.ruzhu
            },
            // 跳转更多公告
            getNotice(){
                this.$router.push({ path:'/notice/notice' })
            },
            // 跳转公告详情
            noticeTap(e){
                this.$router.push({ path:'/notice/noticeDetail', query:{id: e} })
            }
        }
    }
</script>
<style lang="less" scoped>

    .indexContent{
        background: #F7F8FA;
        padding-bottom: 85px;
        .indexBanner{
            width: 100vw;
            height: 25vw;
            overflow: hidden;
            position: relative;
            .slide{
                width: 100vw;
                height: 25vw;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1;
                .banner{
                    width: 100vw;
                    height: 25vw;
                    cursor: pointer;
                }
            }
            .fadeIn-enter-active,.fadeIn-leave-active {
                transition: all 1s ease;
            }
            .fadeIn-enter-active,.fadeIn-leave{
                opacity: 1;
            }
            .fadeIn-enter,.fadeIn-leave-active {
                opacity: 0.1;
            }
            .indicateBox{
                width: 100vw;
                height: 8px;
                position: absolute;
                left: 0;
                bottom: 40px;
                z-index: 2;
                .indicate{
                    width: 8px;
                    height: 8px;
                    border-radius: 4px;
                    background: rgba(255,255,255,0.4);
                    margin-left: 5px;
                    cursor: pointer;
                    &:first-child{
                        margin: 0;
                    }
                }
                .indicateOn{
                    width: 39px !important;
                    background: #fff !important;
                }
            }
        }
       .productContent{
            width: 1232px;
            padding-top: 56px;
            margin: 0 auto;
            .productBox{
                width: 608px;
                .productTitle{
                    width: 118px;
                    height: 24px;
                }
                .productList{
                    width: 608px;
                    padding-top: 16px;
                    .product{
                        width: 160px;
                        height: 176px;
                        padding: 16px;
                        background: #fff;
                        border-radius: 8px;
                        border: 1px solid #F5F5F5;
                        cursor: pointer;
                        .productImg{
                            width: 58px;
                            height: 58px;
                            border-radius: 8px;
                        }
                        .productName{
                            width: 160px;
                            font: 16px/22px "Microsoft YaHei";
                            color: #161825;
                            margin-top: 16px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .productTipsList{
                            width: 160px;
                            height: 28px;
                            margin: 16px 0;
                            .productTips{
                                padding: 0 8px;
                                height: 28px;
                                background: #F1F2FF;
                                border-radius: 4px;
                                font: 14px/28px "Microsoft YaHei";
                                color: #0F59FE;
                                margin-left: 10px;
                                &:first-child{
                                    margin: 0;
                                }
                            }
                        }
                        .price{
                            width: 160px;
                            font: bold 20px/22px "Microsoft YaHei";
                            color: #161825;
                            .priceIcon{
                                font: 16px/22px "Microsoft YaHei";
                            }
                        }
                    }
                }
            }
       }
       .indexModule{
            width: 1232px;
            padding-top: 24px;
            margin: 0 auto;
            .moduleTitle{
                font: 24px/56px "Microsoft YaHei";
                color: #161825;
            }
            .developList{
                width: 1232px;
                .developBox{
                    width: 365px;
                    height: 104px;
                    padding: 16px;
                    background: #fff;
                    border-radius: 8px;
                    border: 1px solid #F5F5F5;
                    margin: 16px 16px 0 0;
                    cursor: pointer;
                    &:nth-child(1){
                        margin-top: 0;
                    }
                    &:nth-child(2){
                        margin-top: 0;
                    }
                    &:nth-child(3){
                        margin-top: 0;
                    }
                    &:nth-child(3n){
                        margin-right: 0;
                    }
                    .developImg{
                        width: 58px;
                        height: 58px;
                        border-radius: 8px;
                    }
                    .develop{
                        padding-left: 12px;
                        .title{
                            width: 295px;
                            font: 16px/22px "Microsoft YaHei";
                            color: #161825;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .tipsList{
                            width: 295px;
                            height: 28px;
                            margin-top: 12px;
                            .tips{
                                padding: 0 8px;
                                height: 28px;
                                background: #F1F2FF;
                                border-radius: 4px;
                                font: 14px/28px "Microsoft YaHei";
                                color: #0F59FE;
                                margin-left: 10px;
                                &:first-child{
                                    margin: 0;
                                }
                            }
                        }
                        .price{
                            width: 295px;
                            font: bold 20px/22px "Microsoft YaHei";
                            color: #161825;
                            margin-top: 16px;
                            .priceIcon{
                                font: 16px/22px "Microsoft YaHei";
                            }
                        }
                    }
                }
                .serviceBox{
                    width: 365px;
                    height: 122px;
                    padding: 16px;
                    background: #fff;
                    border-radius: 8px;
                    border: 1px solid #F5F5F5;
                    margin: 16px 16px 0 0;
                    cursor: pointer;
                    &:nth-child(1){
                        margin-top: 0;
                    }
                    &:nth-child(2){
                        margin-top: 0;
                    }
                    &:nth-child(3){
                        margin-top: 0;
                    }
                    &:nth-child(3n){
                        margin-right: 0;
                    }
                    .serviceImg{
                        width: 200px;
                        height: 122px;
                        border-radius: 8px;
                    }
                    .service{
                        width: 153px;
                        padding-left: 12px;
                        .title{
                            width: 153px;
                            font: 16px/22px "Microsoft YaHei";
                            color: #161825;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                        .text{
                            width: 153px;
                            height: 54px;
                            font: 14px/18px "Microsoft YaHei";
                            color: #73727A;
                            -webkit-line-clamp: 3;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            margin-top: 14px;
                        }
                        .price{
                            width: 153px;
                            font: bold 20px/22px "Microsoft YaHei";
                            color: #161825;
                            margin-top: 10px;
                            .priceIcon{
                                font: bold 16px/22px "Microsoft YaHei";
                            }
                        }
                    }
                }
            }
       }
       .contactList{
            width: 72px;
            position: fixed;
            right: 20px;
            top: 40vh;
            z-index: 999;
            .contactpos{
                width: 72px;
                height: 72px;
                border-radius: 8px;
                background: #fff;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-bottom: 8px;
                cursor: pointer;
                position: relative;
                &:hover{
                    box-shadow: 0px 4px 44px 0px rgba(0,0,0,0.04);
                    .contactShow{
                        display: block;
                    }
                }
                .contactIcon{
                    width: 24px;
                    height: 24px;
                }
                .contactName{
                    font: 12px/16px "Microsoft YaHei";
                    color: #73727A;
                    margin-top: 6px;
                }
                .contactContent{
                    width: 230px;
                    border-radius: 8px;
                    background: #0F59FE;
                    position: absolute;
                    left: -236px;
                    bottom: 0;
                    box-shadow: 0px 4px 44px 0px rgba(0,0,0,0.04);
                    display: none;
                    .contactHi{
                        padding: 18px 0 0 18px;
                        font: bold 14px/18px "Microsoft YaHei";
                        color: #fff;
                    }
                    .contactTitle{
                        padding: 6px 0 0 18px;
                        font: 12px/14px "Microsoft YaHei";
                        color: #fff;
                    }
                    .contactBox{
                        width: 230px;
                        height: 202px;
                        // border-radius: 8px 8px 0 0;
                        background: #fff;
                        margin-top: 12px;
                        .contactImg{
                            width: 138px;
                            height: 138px;
                            border-radius: 12px;
                            margin-top: 21px;
                        }
                        .contactTips{
                            font: 12px/14px "Microsoft YaHei";
                            color: #73727A;
                            margin-top: 6px;
                        }
                    }
                }
                .telBox{
                    padding: 13px 24px;
                    background: #fff;
                    border-radius: 8px;
                    position: absolute;
                    right: 78px;
                    bottom: 0;
                    box-shadow: 0px 4px 44px 0px rgba(0,0,0,0.04);
                    display: none;
                    .telIcon{
                        width: 32px;
                        height: 32px;
                        margin-right: 8px;
                    }
                    .telNum{
                        font: 20px/32px "Microsoft YaHei";
                        color: #161825;
                    }
                    .telName{
                        font: 14px/18px "Microsoft YaHei";
                        color: #161825;
                        margin-top: 4px;
                    }
                    .workTime{
                        font: 12px/16px "Microsoft YaHei";
                        color: #73727A;
                        margin-top: 6px;
                    }
                }
            }
       }
    }
</style>